<template>
  <div class="hideBox">
    <!--   关注   -->
    <focus :item="item" v-if="type!==7"></focus>
    <!--   函询   -->
    <mail :item="item" :type="type"></mail>
    <!--   交流   -->
    <im :item="item"></im>
    <!--   立即报名   -->
    <signName :item="item" v-if="type == 4"></signName>
    <!--   我要报名   -->
    <!-- <signNameMy :item="item" v-if="type == 7"></signNameMy> -->
    <signNameMy :item="item" v-else-if="type == 6"></signNameMy>
    <!--   询价   -->
    <inquiryBtn :item="item" v-else-if="type == 1"></inquiryBtn>
    <!--   查看详细   -->
    <openDetail :item="item" v-else></openDetail>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "hideBox",
  components: {
    focus: () => import('./button/focus'),
    mail: () => import('./button/mail'),
    im: () => import('./button/im'),
    signName: () => import('./button/signName'),
    signNameMy: () => import('./button/signNameMy'),
    openDetail: () => import('./button/openDetail'),
    inquiryBtn: () => import('./button/inquiryBtn'),
  },
  props: {
    item: {
      type: Object
    },
    type: {
      type: [Number,String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工 7工队找活
    }
  },
  data() {
    return {}
  },
  filters: {},
  watch: {},
  computed: {
    ...mapState({
      userNo: state => state.user.no,
      companyNo: state => state.user.companyNo,
      teamNo: state => state.user.teamNo,
    })
  },
  methods: {},
  created() {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
  .hideBox{
    position: absolute;
    width: 100%;
    outline: 1px solid #b79255;
    display: flex;
    /deep/ .button{
      flex:1;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      background: #b79255;
      border: 1px solid #b79255;
      border-top: none;
      margin-right: 1px;

      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      cursor: pointer;
      span{
        display: inline-block;
      }
      img {
        vertical-align: middle;
        margin: -2px 4px 0 0 ;
      }
      &:last-child{
        margin-right: 0;
      }
    }
  }
</style>
